/**
 * Credentials are pasted from customer chats, so stray edge whitespace is
 * common and customers number their backup codes one per line, like
 * "1.12345678".
 */

/** Strips edge whitespace and a leading "N." list number from one backup code. */
export function normalizeBackupCode(code: string): string {
  return code
    .replace(/[۰-۹]/g, d => String(d.charCodeAt(0) - 0x06f0))
    .replace(/[٠-٩]/g, d => String(d.charCodeAt(0) - 0x0660))
    .trim()
    .replace(/^\d{1,2}\s*\.\s*/, '')
    .trim();
}

/** Splits a pasted list of backup codes (commas or line breaks) into clean codes. */
export function parseBackupCodes(text: string): string[] {
  return text.split(/[,\n\r]+/).map(normalizeBackupCode).filter(Boolean);
}

/**
 * Reads a paste into a backup code input as clean codes. Handled by hand
 * because single-line inputs drop the line breaks of a pasted list, gluing the
 * codes together, and so the cleaned codes show before submit.
 */
export function pastedBackupCodes(event: ClipboardEvent): string[] {
  event.preventDefault();
  return parseBackupCodes(event.clipboardData?.getData('text') ?? '');
}
